<template>
	<div>
		<!-- 编辑界面 -->
		<el-drawer :visible.sync="editFormVisible" :title="title" :size="600" class="margin_top_40" :wrapper-closable="false" :modal="false" :destroy-on-close="true" @click="closeDialog">
			<el-form ref="editForm" label-width="8.75rem" :model="editForm" :rules="rules" class="demo-form-inline" inline>
				<el-form-item label="枚举编号" prop="code">
					<el-input clearable v-model="editForm.code" class="input_200px" size="small" auto-complete="off" :disabled="editForm.keyId !== ''" placeholder="请输入枚举编号"></el-input>
				</el-form-item>
				<el-form-item label="枚举名称" prop="name">
					<el-input clearable v-model="editForm.name" class="input_200px" size="small" auto-complete="off" placeholder="请输入枚举名称"></el-input>
				</el-form-item>
				<el-form-item label="样式" prop="styleStr">
					<el-input v-model="editForm.styleStr" class="input_200px" type="textarea" :rows="6" size="small" placeholder="请输入样式"></el-input>
				</el-form-item>
				<el-form-item label="枚举信息描述" prop="description">
					<el-input v-model="editForm.description" class="input_200px" type="textarea" :rows="2" size="small" placeholder="请输入枚举信息描述"></el-input>
				</el-form-item>
				<el-form-item label="显示顺序" prop="seq">
					<el-input v-model.number="editForm.seq" class="input_200px" type="number" size="small"></el-input>
				</el-form-item>
			</el-form>
			<div class="drawer-footer">
				<el-button size="small" icon="el-icon-check" :loading="saveloading" class="title" @click="submitForm('editForm')">保存</el-button>
				<el-button :disabled="editForm.keyId === ''" size="small" type="danger" icon="el-icon-delete" :loading="saveloading" class="title" @click="deleteMenu">删除</el-button>
			</div>
		</el-drawer>
	</div>
</template>
<script>
import { SaveEnumConfig, DelEnumConfig, GetEnumConfigDetail } from "../../../api/enumApi.js";
export default {
	props: [],
	data() {
		return {
			saveloading: false,
			title: "",
			editFormVisible: false, //控制编辑页面显示与隐藏
			editForm: {
				keyId: "",
				name: "",
				code: "",
				description: "",
				parentKeyId: "",
				styleStr: "",
				seq: 0
			},
			// rules表单验证
			rules: {
				name: [
					{
						required: true,
						message: "请输入枚举名称",
						trigger: "blur"
					}
				],
				code: [
					{
						required: true,
						message: "请输入枚举编号",
						trigger: "blur"
					}
				]
			}
		};
	},
	computed: {},
	watch: {},
	methods: {
		// 关闭编辑、增加弹出框
		closeDialog() {
			this.$refs["editForm"].resetFields();
			this.editFormVisible = false;
		},

		//显示编辑界面
		editShow(row, type) {
			if (type === 1) {
				if (row != undefined && row != "undefined") {
					this.title = "编辑";
					this.getEnumConfigDetail(row);
				} else {
					this.title = "新增";
					this.$data.editForm = this.$options.data.call(this).editForm;
				}
			} else if (type === 2) {
				this.title = "新增";
				this.$data.editForm = this.$options.data.call(this).editForm;
				this.editForm.parentKeyId = row.keyId;
			}
			this.editFormVisible = true;
		},

		// 获取详情
		getEnumConfigDetail(row) {
			let param = {
				keyId: row.keyId
			};
			GetEnumConfigDetail(param)
				.then((res) => {
					if (res.code == 1) {
						this.editForm = res.data;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},

		// 编辑、增加页面保存方法
		submitForm(editData) {
			this.$refs[editData].validate((valid) => {
				if (valid) {
					SaveEnumConfig(this.editForm)
						.then((res) => {
							this.loading = false;
							if (res.code === 1) {
								this.editFormVisible = false;
								this.$parent.getListData();
								this.$message({
									type: "success",
									message: "保存成功！"
								});
							} else {
								this.$message({
									type: "error",
									message: res.msg
								});
							}
						})
						.catch((err) => {
							this.loading = false;
							this.$message.error("保存失败，请稍后再试！");
						});
				} else {
					return false;
				}
			});
		},

		// 删除
		deleteMenu() {
			this.$confirm("确定要删除<" + this.editForm.name + ">吗?", "信息", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				let parmter = {
					keyId: this.editForm.keyId
				};
				DelEnumConfig(parmter)
					.then((res) => {
						if (res.code === 1) {
							this.$message({
								type: "success",
								message: "已删除!"
							});
							this.editFormVisible = false;
							this.$parent.getListData();
						} else {
							this.$message({
								type: "info",
								message: res.msg
							});
						}
					})
					.catch((err) => {
						this.loading = false;
						this.$message.error("删除失败，请稍后再试！");
					});
			});
		}
	},
	created() {},
	mounted() {},
	components: {}
};
</script>
<style scoped></style>
